import { useState, useCallback, useEffect } from 'react';
import { SnackbarOptions } from '../types/formContainerProps';


export const useSnackbar = () => {
  const [snackbar, setSnackbar] = useState<SnackbarOptions>({
    useSnackBar: false,
    showSnackbar: false,
    message: '',
    duration: 3000,
    error: false,
    warning: false,
    onCloseSnackbar: () => {},
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
    sx: {}
  });

  const onCloseSnackbar = useCallback(() => {
    setSnackbar((prev) => ({ ...prev, showSnackbar: false }));
  }, []);

  useEffect(() => {
    setSnackbar(prev => ({
      ...prev,
      onCloseSnackbar
    }));
  }, [onCloseSnackbar]);

  const showSuccessSnackbar = useCallback((message: string, duration = 3000) => {
    setSnackbar({
      useSnackBar: true,
      showSnackbar: true,
      message,
      duration,
      error: false,
      warning: false,
      onCloseSnackbar,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      sx: {}
    });
  }, [onCloseSnackbar]);

  const showErrorSnackbar = useCallback((message: string, duration = 4000) => {
    setSnackbar({
      useSnackBar: true,
      showSnackbar: true,
      message,
      duration,
      error: true,
      warning: false,
      onCloseSnackbar,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      sx: {}
    });
  }, [onCloseSnackbar]);

  const showWarningSnackbar = useCallback((message: string, duration = 4000) => {
    setSnackbar({
      useSnackBar: true,
      showSnackbar: true,
      message,
      duration,
      error: false,
      warning: true,
      onCloseSnackbar,
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      sx: {}
    });
  }, [onCloseSnackbar]);

  const closeSnackbar = useCallback(() => {
    setSnackbar((prev) => ({ ...prev, showSnackbar: false }));
  }, []);

  return {
    snackbar,
    showSuccessSnackbar,
    showErrorSnackbar,
    showWarningSnackbar,
    closeSnackbar
  };
};